import internalChatPollsAPI from 'dashboard/api/internalChatPolls';

const state = {
  // keyed by poll id → poll object
  polls: {},
};

const getters = {
  getPollById: s => id => s.polls[id] || null,
};

const mutations = {
  UPSERT_POLL(s, poll) {
    s.polls = { ...s.polls, [poll.id]: poll };
  },
};

const actions = {
  async createPoll({ commit }, { channelId, question, options }) {
    const { data } = await internalChatPollsAPI.createPoll({
      channel_id: channelId,
      question,
      options,
    });
    const poll = data?.data || data;
    commit('UPSERT_POLL', poll);
    return poll;
  },

  async vote({ commit }, { pollId, optionId }) {
    const { data } = await internalChatPollsAPI.vote(pollId, optionId);
    const poll = data?.data || data;
    commit('UPSERT_POLL', poll);
  },

  async unvote({ commit }, { pollId, optionId }) {
    const { data } = await internalChatPollsAPI.unvote(pollId, optionId);
    const poll = data?.data || data;
    commit('UPSERT_POLL', poll);
  },

  updatePollFromCable({ commit }, { poll }) {
    if (poll) commit('UPSERT_POLL', poll);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
